import type { RouteLocationNormalized, RouteLocationRaw } from "vue-router";

import { windowSize } from "@/utils/dom/coordinates";

import type { Params, Query } from "../types";

export function isSmallScreen() {
  return windowSize().x <= 1000;
}

export function companyParam() {
  const search = new URLSearchParams(window.location.search.substring(1));
  return search.get("company");
}

export function removeCompanyParam() {
  const url = new URL(window.location.href);
  url.searchParams.delete("company");
  window.history.replaceState(window.history.state, "", url.toString());
}

export function isBoardChange(from: RouteLocationNormalized, to: RouteLocationNormalized) {
  return (
    to.name !== from.name ||
    to.params.session !== from.params.session ||
    to.params.team !== from.params.team ||
    to.params.board !== from.params.board ||
    to.params.name !== from.params.name
  );
}

export function replaceParams(to: RouteLocationNormalized, params: Params): RouteLocationRaw {
  return replaceRoute(to, { params });
}

export interface ParamsAndQuery {
  params: Params;
  query: Omit<Query, "search">;
}

export function replaceRoute(
  to: RouteLocationNormalized,
  pq: Partial<ParamsAndQuery>,
): RouteLocationRaw {
  return {
    replace: true,
    name: to.name || undefined,
    params: { ...to.params, ...pq.params },
    query: { ...to.query, ...pq.query },
  };
}
